import React, {useContext} from "react";
import {createUseStyles} from "react-jss";
import {EngageAppContext} from "../../App";
import {TriviaRunning, triviaStateDuration, TriviaStatus} from "../../state/state";
import {EngageMessageType} from "engage-common/messages";
import {useCountdown} from "../../hooks/useCountdown";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import Button from "engage-client/components/Button";
import StateUpload from "./StateUpload";
import Modal from "engage-client/components/Modal";

const useStyles = createUseStyles({
	data: {
		marginTop: 5,
		marginBottom: 16,
	},
	button: {
		margin: 8
	},
	modalContent: {
		borderRadius: 5,
		padding: 0,
		boxShadow: "0 4px 8px 0 rgb(255 255 255 / 20%), 0 6px 20px 0 rgb(255 255 255 / 19%)"
	}
});

export default function HostState() {
	const {appState, lobby, sendMessage} = useContext(EngageAppContext.current);
	const [uploadOpen, setUploadOpen] = React.useState(false);
	const classes = useStyles();
	const stateDuration = triviaStateDuration(appState.common);
	const countdown = useCountdown(appState.common.timeMark, stateDuration, appState.common.pauseMark);

	function openStateUpload() {
		if(appState.common.state === TriviaStatus.Pending) {
			setUploadOpen(true);
		} else {
			alert("Trivia State must be pending upload state, which will set the game state to what you upload. Use RESET! before changing questions.");
		}
	}

	function closeStateUpload() {
		setUploadOpen(false);
	}

	function downloadLobbyData(){
		if(lobby && window.confirm("Do you want to download the full state? It can be quite large!")) {
			sendMessage({
				type: EngageMessageType.GetDownloadState,
				lobbyID: lobby.id
			}, (fullState:any) => {
				const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(fullState));
				let downloadAnchorNode = document.createElement("a");
				downloadAnchorNode.setAttribute("href",     dataStr);
				downloadAnchorNode.setAttribute("download", "lobbyData.json");
				document.body.appendChild(downloadAnchorNode); // required for firefox
				downloadAnchorNode.click();
				downloadAnchorNode.remove();
			});
		}
	}

	return (
		<div>
			<DisplayText variant={TextVariant.s16reg} color="primary">Current State:</DisplayText>
			<DisplayText variant={TextVariant.s16reg} fontWeight={400} className={classes.data} color="primary">
				{appState.common.state} {appState.common.pauseMark ? "- paused" : null}
			</DisplayText>
			{
			TriviaRunning.includes(appState.common.state) ? (
				<>
					<DisplayText variant={TextVariant.s16reg} color="primary">Showing question:</DisplayText>
					<DisplayText variant={TextVariant.s16reg} fontWeight={400} className={classes.data} color="primary">
						{appState.common.currentIndex + 1} of {appState.common.totalQuestions}
					</DisplayText>
					<DisplayText variant={TextVariant.s16reg} color="primary">Current Question:</DisplayText>
					<DisplayText variant={TextVariant.s16reg} fontWeight={400} className={classes.data} color="primary">
						 {appState.common.currentQuestion?.prompt}
					</DisplayText>
					{ !appState.common.gameOptions.selfTimed &&
						<>
						<DisplayText variant={TextVariant.s16reg} color="primary">State Ends In:</DisplayText>
						<DisplayText variant={TextVariant.s16reg} fontWeight={400} className={classes.data} color="primary">
							{countdown}
						</DisplayText>
						</>
					}
				</>
			) : (
				<>
					<DisplayText variant={TextVariant.s16reg} color="primary">Total Questions:</DisplayText>
					<DisplayText variant={TextVariant.s16reg} fontWeight={400} className={classes.data} color="primary">
						{appState.common.totalQuestions}
					</DisplayText>
				</>
			)
			}
			<Button onClick={downloadLobbyData} className={classes.button}>Download State</Button>
			<Button onClick={openStateUpload} className={classes.button}>Upload State</Button>
			<Modal
				isVisible={uploadOpen}
				onBackdropClick={closeStateUpload}
				contentClassname={classes.modalContent}
			>
				<StateUpload closeHandler={closeStateUpload}/>
			</Modal>
		</div>
	);

};